import { render } from "./SmoothScrollContainer.vue?vue&type=template&id=4e2e595d"
import script from "./SmoothScrollContainer.vue?vue&type=script&lang=js"
export * from "./SmoothScrollContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__